import type { IconProps } from './icon.types'

const ArrowRightIcon = (props: IconProps) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='arrow-right-icon'
    {...props}
  >
    <path d='M4 9h10' />
    <path d='M9.5 4.5 14 9l-4.5 4.5' />
  </svg>
)

export default ArrowRightIcon
